import React from 'react';
import { FormattedDate } from 'react-intl';

import useFormatTimeTimeZone from 'hooks/useFormatTimeTimeZone';
import { DATETIME_FORMAT } from 'utils/dateFormats';

import type { StandardDateProps as StandardDateTimeProps } from './StandardDate';

const StandardDateTime: React.FC<StandardDateTimeProps> = ({ value, dealerId, systemTimezone }) => {
  const timeZoneProps = useFormatTimeTimeZone({ dealerId, systemTimezone });
  if (!value) {
    return null;
  }
  return (
    // eslint-disable-next-line no-restricted-syntax
    <FormattedDate value={value} {...DATETIME_FORMAT} {...timeZoneProps} />
  );
};

export default StandardDateTime;
